// https://tc39.es/ecma262/#sec-iscallable

var isCallable = function (argument) {
  return typeof argument == 'function';
};

export { isCallable as default };
